import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Store from "logic/local-storage/Store";
import useHistory from "routing/useHistory";
const OidcCallbackPage = () => {
  const { t } = useTranslation("enterprise_authentication");
  const nonce = Store.sessionGet("nonce");
  const history = useHistory();
  useEffect(() => {
    history.replace((nonce == null ? void 0 : nonce.redirectTo) || "/");
  }, [nonce]);
  useEffect(
    () => () => {
      Store.sessionDelete("nonce");
    },
    []
  );
  return /* @__PURE__ */ React.createElement("div", null, t("cloud_oidc_callback_page.logged_in"));
};
export default OidcCallbackPage;
